module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAdUlEQVR4Ae3WAQaAMACF4ZVuEaqgi3aGAQa6R2eJoVu8DEWA8GN53wH+Z7AtGMbMNGgi870OZc1kvji1kPliZfORzSc4r6bi/EbnW+dftOuW1THXWv5+Ak809ET6x0QI9ETkJ1Zu4nmTuYnyq+Bo1BCqYWZ2Ad9wH3azBBnjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Datebox/baseline_keyboard_arrow_left_white_24dp.png
// module id = 94
// module chunks = 0